import {
  Button,
  CurrencySelectInput,
  LongArrowIcon,
  SearchInput,
} from '@libs/components';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.6rem 2rem;
  ${({ theme }) => theme.media.tabletL`
  padding: 2rem 3.6rem 3.6rem 3.6rem;
`}
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  .input-placeholder {
    white-space: unset;
  }
`;

export const InputsMiddlePart = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
export const ArrowIconWrapper = styled.div`
  z-index: ${({ theme }) => theme.zIndex.low};
  position: absolute;

  display: flex;

  background-color: ${({ theme }) => theme.colors.surface.default};
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: ${({ theme }) => theme.borderRadius.x2};
  border: 0.4rem solid ${({ theme }) => theme.colors.surface.tertiary};
`;
export const CustomCurrencySelectInput = styled(CurrencySelectInput)`
  .input-placeholder {
    white-space: unset;
  }
`;

export const ArrowIcon = styled(LongArrowIcon)`
  transform: rotate(90deg);
  width: 1.6rem;
  height: 1.6rem;
`;

export const CustomButton = styled(Button)`
  margin-top: 2rem;
`;

export const SelectSearchWrapper = styled.div`
  padding: 0.8rem 3.2rem 1.2rem;
  min-width: 100%;
  ${({ theme }) => theme.media.tabletL`
    min-width:42.8rem;
  `}
`;
export const CustomSearch = styled(SearchInput)`
  border-radius: ${({ theme }) => theme.borderRadius.x8};
`;

export const EmptyDivWidth = styled.div`
  min-width: 100%;
  ${({ theme }) => theme.media.tabletL`
    min-width:42.8rem;
  `}
`;
